<template>
  <el-dialog
    :title="isEdit ? '编辑活动通知' : '新建活动通知'"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      size="small"
    >
      <!-- 图片上传 -->
      <el-form-item label="图片" prop="url">
        <el-upload
          :class="{ 'hide-upload': fileList.length >= 1 }"
          :action="uploadUrl"
          accept=".png,.jpeg,.jpg"
          :before-upload="beforeUpload"
          list-type="picture-card"
          :file-list="fileList"
          :limit="1"
          :on-success="handleUploadSuccess"
          :on-remove="handleUploadRemove"
          :on-exceed="handleExceed"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <!-- 时间设置 -->
      <el-form-item label="时间" prop="dateRange">
        <el-date-picker
          v-model="form.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy.MM.dd"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>

      <!-- 是否展示 -->
      <el-form-item label="是否展示" prop="status">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { BASE } from "@/common/api";

export default {
  name: "ActivityDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploadUrl: BASE + "/user/popup/uploadPic", // 上传接口
      submitLoading: false,
      fileList: [],
      form: {
        url: "",
        dateRange: [],
        status: false,
      },
      rules: {
        url: [{ required: true, message: "请上传图片", trigger: "change" }],
        dateRange: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    isEdit() {
      return !!this.rowData;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.isEdit && this.rowData) {
        // 解析传进来的 rowData 的时间范围
        const dateRange = this.rowData.date ? this.rowData.date.split("-") : [];
        this.form = {
          url: this.rowData.url || "",
          dateRange: dateRange,
          status:
            this.rowData.status !== undefined ? this.rowData.status : true,
        };
        // 回显图片上传
        if (this.rowData.url) {
          this.fileList = [{ name: "pic", url: this.rowData.url }];
        } else {
          this.fileList = [];
        }
      } else {
        // 重置为新建表单的默认值
        this.form = {
          url: "",
          dateRange: [],
          status: true,
        };
        this.fileList = [];
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    // 上传限制
    handleExceed() {
      this.$message.warning("只能上传一张图片");
    },
    // 上传校验格式
    beforeUpload(file) {
      const fileName = file.name || "";
      const extension = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      const isAccept = ["png", "jpeg", "jpg"].includes(extension);
      if (!isAccept) {
        this.$message.error("请上传 png、jpeg、jpg 格式的图片");
        return false;
      }
      return true;
    },

    // 图片上传成功
    handleUploadSuccess(res, file) {
      if (res.code === 0) {
        this.form.url = res.data.path;
        this.fileList = [{ name: file.name, url: this.form.url }];
        this.$refs.form.validateField("url");
      } else {
        this.$message.error(res.msg || "上传失败");
        this.fileList = [];
      }
    },
    // 图片删除
    handleUploadRemove() {
      this.form.url = "";
      this.fileList = [];
      this.$refs.form.validateField("url");
    },
    handleClose() {
      this.$refs.form.resetFields();
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 拼接最终时间格式为 "YYYY.MM.DD-YYYY.MM.DD"
          const dateStr = this.form.dateRange.join("-");
          const postData = {
            url: this.form.url,
            date: dateStr,
            dateRange: this.form.dateRange,
            status: this.form.status,
          };
          if (this.isEdit) {
            postData.id = this.rowData.id; // 如果是编辑，保留ID
          }

          this.submitLoading = true;
          // 发送 submit 事件给父组件，父组件处理保存接口后调用回调函数
          this.$emit("submit", postData, (success) => {
            this.submitLoading = false;
            if (success !== false) {
              this.dialogVisible = false;
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tips-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

::v-deep .hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}

// 移除图片上传列表的过渡动画，避免删除时出现淡出延迟
::v-deep .el-upload-list__item {
  transition: none !important;
}
::v-deep .el-list-leave-active {
  transition: none !important;
}
</style>
